module.exports = __webpack_public_path__ + "media/images/rabas_logo_simple-dabc171255e99fb7d3d5a5c95c414711.png";